<template>
  <div class="q-pa-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      :rows="rows"
      :columns="columns"
      class="tabela-tamanho-fixo"
      :loading="disable"
      dense
      hide-pagination
      :rows-per-page-options="[0]"
    >
      <template #body-cell-submenus="props">
        <q-td>
          {{ props.row.id }}
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "display_name",
    label: "Role",
    field: "display_name",
    align: "left",
  },
  {
    name: "description",
    label: "Descrição",
    field: "description",
    align: "left",
  },
];

import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const rows = ref([]);

    const disable = ref(true);
    const selected = ref(0);
    const value = ref([]);
    const subMenu = ref("");
    const filter = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 8,
      rowsNumber: 15,
    });

    const getMenu = async (page = 0, rowsPerPage = 8) => {
      const response = await store.dispatch("adminMultpex/getRoles", {
        page,
        per_page: rowsPerPage,
        search: filter.value,
      });
      rows.value = response.data.results.data;
      disable.value = false;
    };

    onMounted(getMenu);

    const handleRequest = async () => {
      getMenu(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selected,
      subMenu,
      value,
      handleRequest,
      filter,
    };
  },
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
</style>
